export const authDecision = ({ user, loading }) => loading ? 'loading' : user ? 'allow' : 'login';
export const adminDecision = ({ user, loading }) => loading ? 'loading' : !user ? 'login' : user.role === 'ADMIN' ? 'allow' : 'home';
export const demoRouteDecision = ({ user, loading }) => loading ? 'loading' : user?.role === 'PARTNER_DEMO' ? 'library' : 'allow';
